export enum TabType {
  PLAN_UNIT_DETAILS = 'plan-unit-details',
  DUTY_CODES = 'duty-codes',
  PREFERENCES = 'preferences',
  SETTINGS = 'settings',
  FORMATION_AND_SORT_ORDER = 'formation-and-sort-order',
  CLUSTERS = 'clusters',
  COST_CALCULATION_SETTINGS = 'cost-calculation-settings'
}
